var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankSellConfirm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "166px",
    height: "122px",
    viewBox: "0 0 166 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-4-/-one-conf-updated-icons-add-bank",
    transform: "translate(-637.000000, -520.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(588.000000, 520.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(50.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.181818,117.498814 C134.181818,119.986561 110.596756,122 81.5040981,122 C52.4093051,122 28.8242424,119.986561 28.8242424,117.498814 C28.8242424,115.013439 52.4093051,113 81.5040981,113 C110.596756,113 134.181818,115.013439 134.181818,117.498814",
    id: "Fill-9",
    fill: "#E6F9FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.8367347,0 C41.2470459,0 7.53061224,33.931775 7.53061224,75.7870903 C7.53061224,86.9372659 9.94229082,97.5152491 14.2403878,107.049265 L151.433082,107.049265 C155.731179,97.5152491 158.142857,86.9372659 158.142857,75.7870903 C158.142857,33.931775 124.426423,0 82.8367347,0 Z",
    id: "Fill-1",
    fill: "#E6F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47193878,107.049265 L155.318878,107.049265",
    id: "Stroke-3",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,107.049265 L4.70663265,107.049265",
    id: "Stroke-5",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.084184,107.049265 L163.790816,107.049265",
    id: "Stroke-7",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(26.836364, 21.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-17",
    fill: "#FFFFFF",
    x: 11.9272727,
    y: 40,
    width: 75.5393939,
    height: 45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#054C70",
    fill: "#FFFFFF",
    x: 0.5,
    y: 84.5,
    width: 104.357576,
    height: 9,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    stroke: "#054C70",
    fill: "#FFFFFF",
    x: 9.44545455,
    y: 44.5,
    width: 14.9030303,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy-2",
    stroke: "#054C70",
    fill: "#FFFFFF",
    x: 45.2272727,
    y: 44.5,
    width: 14.9030303,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy-3",
    stroke: "#054C70",
    fill: "#FFFFFF",
    x: 82.0030303,
    y: 44.5,
    width: 14.9030303,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    stroke: "#054C70",
    fill: "#FFFFFF",
    x: 4.47575758,
    y: 40.5,
    width: 23.8484848,
    height: 4,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-3",
    stroke: "#054C70",
    fill: "#FFFFFF",
    x: 4.47575758,
    y: 80.5,
    width: 23.8484848,
    height: 4,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    stroke: "#054C70",
    fill: "#FFFFFF",
    x: 40.2575758,
    y: 40.5,
    width: 23.8484848,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-4",
    stroke: "#054C70",
    fill: "#FFFFFF",
    x: 40.2575758,
    y: 80.5,
    width: 23.8484848,
    height: 4,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-2",
    stroke: "#054C70",
    fill: "#FFFFFF",
    x: 77.0333333,
    y: 40.5,
    width: 23.8484848,
    height: 4,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-5",
    stroke: "#054C70",
    fill: "#FFFFFF",
    x: 77.0333333,
    y: 80.5,
    width: 23.8484848,
    height: 4,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5702546,2.04959153 L96.4121212,31 L8.94545455,31 L49.7873211,2.04959153 C51.5194536,0.821784215 53.8381222,0.821784215 55.5702546,2.04959153 Z",
    id: "Triangle-2-Copy",
    stroke: "#054C70",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6230304,12.1450379 L81.5030303,31 L23.8545455,31 L49.7345454,12.1450379 C51.4892241,10.8666608 53.8683517,10.8666608 55.6230304,12.1450379 Z",
    id: "Triangle-2",
    stroke: "#054C70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    stroke: "#054C70",
    fill: "#FFFFFF",
    x: 7.45757576,
    y: 31.5,
    width: 90.4424242,
    height: 9,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(116.290909, 85.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#054C70"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 14.9090909,
    cy: 15,
    rx: 14.9090909,
    ry: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(9.939394, 3.000000)",
    stroke: "#05C3DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9875095,21.3978495 L4.9875095,23.4721784",
    id: "Stroke-71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9875095,0.896057348 L4.9875095,2.97038631",
    id: "Stroke-73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.712501358,16.6395222 C0.712501358,18.9311618 2.55773447,20.7881801 4.83483064,20.7881801 C7.1099638,20.7881801 8.95715992,18.9311618 8.95715992,16.6395222 C8.95715992,14.3478825 7.1099638,12.4908642 4.83483064,12.4908642 C2.55773447,12.4908642 0.712501358,10.6338459 0.712501358,8.34220631 C0.712501358,6.0505667 2.55773447,4.19354839 4.83483064,4.19354839 C7.1099638,4.19354839 8.95715992,6.0505667 8.95715992,8.34220631",
    id: "Stroke-75",
    strokeWidth: 2
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankSellConfirm);
export default __webpack_public_path__ + "static/media/bank-sell-confirm.9c475235dab8b63b9518fe82c5887092.svg";
export { ForwardRef as ReactComponent };